// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { useI18n } from "@/i18n"

/**
 * Marks a price as a real, observed value (Money status 'cached' — an
 * Open Prices or retailer-feed price, per Track A), distinct from
 * EstimatedBadge's hand-curated fallback. Never implies a per-store
 * guarantee on its own — pair with the price's `basis` provenance line.
 */
export function RealPriceBadge({ className }: { className?: string }) {
  const { t } = useI18n()
  return (
    <span
      className={`inline-flex items-center rounded-bb-full bg-green/15 px-2 py-0.5 text-xs font-medium text-green ${className ?? ""}`}
    >
      {t("views.shop.realPriceBadge")}
    </span>
  )
}
